import React from "react";
import Number from "./number";
import Button from "./button";

import "../../styles/components/selectedNumber.scss";
import Icon from "./icon";

export default class SelectedNumber extends React.Component {
    constructor(props) {
        super(props);

        /**
         * @type {{
         *  number: number,
         *  amount: number,
         *  value: number,
         *  onRemove: Function,
         *  readonly?: boolean,
         *  numberLength?: number
         * }}
         */
        this.props;
    }

    render() {
        const { number, amount, onRemove, readonly, numberLength } = this.props;

        return <React.Fragment>
            <div className="selected-number">
                <div className="selected-number__wrapper">
                    {readonly ? null : 
                        <div className="selected-number__remove" onClick={() => onRemove()}>
                            <Icon type="minus" color="danger">X</Icon>
                        </div>
                    }
                    <Number readonly number={number} numberLength={numberLength} />
                </div>

                {amount > 1 ?
                    <div className="selected-number__amount">
                        <span className="selected-number__amount__x">x</span>
                        <span className="selected-number__amount__number">{amount}</span>
                    </div>
                    : null}
            </div>
        </React.Fragment>
    }
}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/selectedNumber.jsx